import gql from 'graphql-tag';

export const integrationDropboxFragment = gql`
  fragment integrationDropboxFragment on IntegrationDropbox {
    dokkioClass
    id
    accountID
    syncFolderRemoteID
    syncFolderPath
  }
`;
export default integrationDropboxFragment;
